import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function querySopExternalCode() {
  return request({
    url: URL.sys.querySopExternalCode,
    method: 'get'
  })
}
